import { createUseConfig } from '@zurich/common/contexts';
import type { BaseConfig } from '@zurich/common/types';

export interface Config extends BaseConfig {
  // add custom configuration here
}

const useConfig = createUseConfig<Config>();

export { useConfig };
